import React, { useCallback, useEffect, useState } from "react";
import HorizontalDivider from "src/components/HorizontalDivider/HorizontalDivider";
import BMCWithRatingGrid from "./BMCWithRatingGrid";
import BMCWithRatingFilter from "./BMCWithRatingFilter";
import { Button } from "primereact/button";
import { ReactComponent as ExportIcon } from "src/assets/icons/export.svg";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import useRefreshData from "src/hooks/useRefreshData";
import { exportFormattedData, getCompanyPaymentStatus } from "src/utils/common";
import {
  getBMCWithRating,
  resetFilterData,
  selectBMCWithRatingForExport,
} from "src/redux/slices/bmcWithRatingSlice";
import { DownloadViewPrefixes } from "src/resources/enum";
import { BMCWithRatingsColumns } from "src/resources/constant";
import { getBMCList } from "src/redux/slices/civilDefenseSlice";
import "./BMCWithRating.scss";
const BMCWithRating = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["common", "registration", "assignedBuildings"]);

  const [shouldExport, setShouldExport] = useState(false);
  useEffect(() => {
    dispatch(getBMCList() as any);
  }, [dispatch]);

  const breadCrumbsPaths = useSelector(
    (state: any) => state.breadCrumb.breadCrumbItems
  );
  const bmcWithRatingDataForExport = useSelector(selectBMCWithRatingForExport);

  useRefreshData(getBMCWithRating);

  useEffect(() => {
    dispatch(resetFilterData());
  }, []);

  const getMappedData = (data: any) => {
    return data.map((item: any) => {
      return {
        ...item,
        companyName: item.name,
        rating: item?.rating + "% (" + t(item.ratingText?.toLowerCase()) + ")",
        paymentStatus: t(getCompanyPaymentStatus(item?.paymentStatus)),
        numberOfBuildings:item.numberOfBuildings,
        tradeLicenseNumber:item.tradeLicenseNumber,
        // ComplianceSLA:item.ComplianceSLA,
        // CompliancePerBuilding:item.CompliancePerBuilding,
      };
    });
  };
  const exportFile = useCallback(() => {
    if (bmcWithRatingDataForExport.length > 0) {
      let mappedData = getMappedData(bmcWithRatingDataForExport);
      console.log({ mappedData });
      exportFormattedData(
        mappedData,
        BMCWithRatingsColumns,
        DownloadViewPrefixes.BMCWithRatings,
        t
      );
    }
  }, [bmcWithRatingDataForExport, t]);

  useEffect(() => {
    if (shouldExport) {
      exportFile();
      setShouldExport(false);
    }
  }, [exportFile, shouldExport]);

  const exportExcelHandler = (): void => {
    dispatch(getBMCWithRating(true) as any).then(() => {
      setShouldExport(true);
    });
  };

  return (
    <div className="py-2">
      <div className="d-flex justify-content-between pb-3 px-3">
        {breadCrumbsPaths.length && (
          <h2 className="inner-page-title">
            {t(breadCrumbsPaths[breadCrumbsPaths.length - 1].label)}
          </h2>
        )}
        <div className="inner-page-search gap-2">
          <Button
            className="d-flex gap-2 light-primary-btn m-0"
            label={t("export")}
            icon={<ExportIcon className="m-0" />}
            onClick={exportExcelHandler}
          ></Button>
        </div>
      </div>
      <HorizontalDivider />
      <BMCWithRatingFilter />
      <HorizontalDivider />
      <BMCWithRatingGrid />
    </div>
  );
};

export default BMCWithRating;
